import { useEffect, useState } from 'react';
import { AppSettingsVar } from '../../../_project/settings';
import useButtonActions from '../../../hooks/use-button-actions';
import i18n from '../../../i18n';

const RadioCards = ({
      fieldName, 
      label, 
      options, 
      helpText, 
      required, 
      value, 
      placeholder, 
      disabled, 
      style={}, 
      inputClass, 
      errors, 
      choices, 
      selectAddUrl = '',
      selectAddField = '',
      onChange = () => {},
      pk = null
    }
) => {
  const [newCreated, setNewCreated] = useState([])
  const finalizeTag = (id, tag, isNew)=> {
    options.push({id:id,label:tag, disabled:false})
    setNewCreated( newCreated =>[...newCreated, id])
  }
  const  getButtonActions = useButtonActions()
  const action = getButtonActions(null, {'action_id': selectAddUrl}, 'btn btn-sm ms-1 my-auto rounded ' + AppSettingsVar.button_class, '', true, null, null, null, false, 'pop_over', finalizeTag)

  const [inputValue, setInputValue] = useState(value);
  const localOnChange = (e) => {
    setInputValue(e.target.value)
    onChange({'name':fieldName, 'value': e.target.value, 'label': options.find(option => option.id === e.target.value)?.label})
  }
  useEffect(() => {
    setInputValue(value)
  }, [value])


  const handleKeyDown = (e, option) => {
    if (e.key === ' ' && !option.disabled) {
      const input = e.target.querySelector('input');
      if (input) {
        input.checked = true;
        const event = {
          type: 'change',
          target: input,
          currentTarget: input,
          preventDefault: () => {},
          stopPropagation: () => {}
        };
        localOnChange(event);
      }
    }
  } 

  return ( <div className="d-flex align-item-center radio-wrapper">
            {options && options.map( (option) =>
              <label 
                key={pk ? pk + '_' + fieldName + '_' + option.id : fieldName + '_' +  option.id} 
                id={pk ? pk + '_' + fieldName + '_' + option.id : fieldName + '_' +  option.id}
                tabIndex={0} 
                className={`${fieldName}-existing radio radio-card ${style.class}`}
                onKeyDown={(e) => handleKeyDown(e, option)}
              >
                <input  
                  type="radio" 
                  name={fieldName} 
                  value={option.id} 
                  // defaultChecked={value === option.id || newCreated.includes(option.id)} 
                  checked={inputValue === option.id || newCreated.includes(option.id)}
                  onChange={localOnChange}
                  disabled={option.disabled || disabled}
                />
                {option.label }
              </label>
            )}
            {(!options || options.length == 0) && <p>{i18n.t('No {{label}} possible', {label: label} )}</p>}
            {action}
          </div>
  )
}

export default RadioCards
